import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNotes, deleteNoteAction } from 'Store/Notes/Actions';
import NoteEditor from './NewDesign/NoteEditor'; 
import { ListGroup, Button } from 'react-bootstrap';

const NotesComponent = ({ conceptId }) => {
  const dispatch = useDispatch();
  const notes = useSelector((state) => state.notes.notes);
  
  // 1. Add state to toggle the editor
  const [isEditorOpen, setIsEditorOpen] = useState(false);

  useEffect(() => {
    if (conceptId) {
      dispatch(getNotes(conceptId));
    }
  }, [dispatch, conceptId]);

  const handleDelete = (noteId) => {
    console.log("DEBUG: Note object being deleted:", noteId);
    dispatch(deleteNoteAction(noteId));
  };
  return (
    <div className="notes-container ml-3 mr-3 mt-3">
      <div className="d-flex justify-content-between align-items-center">
        <h3>My Notes</h3>
        {/* 2. Button to toggle editor */}
        <Button 
          variant="primary" 
          onClick={() => setIsEditorOpen(!isEditorOpen)}
        >
          {isEditorOpen ? "Close Editor" : "+ Add Note"}
        </Button>
      </div>
      
      {/* 3. Conditionally render the editor */}
      {isEditorOpen && (
        <NoteEditor 
          conceptId={conceptId} 
          onClose={() => setIsEditorOpen(false)} 
        />
      )}

      {/* List of existing notes */}
      <ListGroup className="mt-3">
        {notes && notes.length > 0 ? (
          notes.map((note) => (
            <ListGroup.Item key={note.id} className="d-flex justify-content-between">
              <span>{note.content}</span>
              <Button 
                variant="danger" 
                size="sm" 
                onClick={() => handleDelete(note.id)}
              >
                Delete
              </Button>
            </ListGroup.Item>
          ))
        ) : (
          <p className="text-muted mt-2">No notes available. Start by adding one!</p>
        )}
      </ListGroup>
    </div>
  );
};

export default NotesComponent;